import React, { memo, Key } from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import { upperCaseHandler } from '@utils';
import './DataCard.scss';

interface DataCardRowProps {
	children?: ReactNode;
	title: string | Key;
}

export const DataCard: FunctionComponent<DataCardRowProps> = memo(({ children, title }) => (
	<section className="data-card">
		<h5 className="data-card__heading">{upperCaseHandler(title)}</h5>
		{children}
	</section>
));
